module.exports = "<list-view\n  title=\"Contractors\"\n  item-state=\"contractor\"\n  filter-event=\"$ctrl.filterEvent\"\n  transformer=\"ContractorsTransforms\"\n  resource=\"Contractors\"\n  add-item-event=\"$ctrl.addItemEvent\"\n  add-item-customize-options=\"$ctrl.addItemCustomizeOptions\"\n  page=\"$ctrl.page\"\n  total=\"$ctrl.total\"\n  limit=\"$ctrl.limit\"\n  paginate-event=\"$ctrl.paginateEvent\"\n  no-items-text=\"No Contractors Yet!\"\n></list-view>\n\n<main-footer></main-footer>\n<main-sidenav sections=\"$ctrl.sections\">\n  <main-sidenav></main-sidenav>\n</main-sidenav>\n";


//////////////////
// WEBPACK FOOTER
// ./src/pages/contractors/contractors.html
// module id = 2005
// module chunks = 0